<template>
  <FiltersChip
    :text="filter.text"
    :value="displayValue"
    @clear="clear"
  >
    <template #form="{ hide }">
      <v-form
        v-model="formValid"
        @submit.prevent="() => submit(hide)"
      >
        <DebouncedSelect
          v-model="localValue"
          :initial-item="localValue"
          :service="filter.service"
          placeholder="Start typing to search"
          item-text="name"
          :label="`${filter.text} values`"
          chips
          :multiple="filter.multiple"
          return-object
        />
        <v-btn
          class="mt-2"
          color="primary"
          type="submit"
          small
          :disabled="!formValid"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Apply
        </v-btn>
        <v-btn
          class="ml-2 mt-2"
          small
          @click="hide"
        >
          <v-icon
            left
            small
          >
            mdi-cancel
          </v-icon>
          Cancel
        </v-btn>
      </v-form>
    </template>
  </FiltersChip>
</template>

<script>
import DebouncedSelect from '@/components/common/DebouncedSelect.vue';
import FiltersChip from './FiltersChip.vue';

export default {
  name: 'CaseActivityFiltersDebouncedSelect',
  components: {
    DebouncedSelect,
    FiltersChip,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.filter.multiple ? [] : null,
      displayValue: '',
      formValid: false,
    };
  },
  computed: {
    serviceHandler() {
      const keys = this.filter.service.split('.');
      let handler = this.$service;
      keys.forEach((k) => {
        handler = handler[k];
      });
      return handler.list;
    },
  },
  watch: {
    values(val) {
      if (!val[this.filter.name]) {
        this.localValue = [];
        this.setDisplayValue();
      }
    },
  },
  async created() {
    const initialValue = this.values[this.filter.name] || (this.filter.multiple ? [] : null);
    if (this.filter.multiple && initialValue.length > 0) {
      const resp = await this.serviceHandler({ params: { id: initialValue, page_size: 50 } });
      this.localValue = resp.data.results.filter((r) => initialValue.includes(r.id)).map(
        (r) => ({ id: r.id, name: r.name }),
      );
    } else if (!this.filter.multiple && initialValue) {
      const resp = await this.serviceHandler({ params: { id: initialValue, page_size: 50 } });
      this.localValue = resp.data.results.find((r) => r.id === initialValue);
    }
    this.setDisplayValue();
  },
  methods: {
    submit(hideCallback) {
      this.setDisplayValue();
      const selectedValues = this.filter.multiple ? this.localValue : [this.localValue];
      this.$emit('apply', { [this.filter.name]: selectedValues.map((v) => v.id) });
      hideCallback();
    },
    clear() {
      this.localValue = this.filter.multiple ? [] : null;
      this.setDisplayValue();
      this.$emit('apply', { [this.filter.name]: undefined });
    },
    setDisplayValue() {
      const selectedValues = this.filter.multiple ? this.localValue : [this.localValue];
      this.displayValue = selectedValues.map((v) => v.name).join(', ');
    },
  },
};
</script>
